import React  from "react";
import Layout from "../../components/Layout";
import { Outlet, useOutletContext } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { RootState } from "../../store/index";
import { useSelector } from "react-redux";
import ErrorFallback from "../../components/ErrorFallback";
import { Checkpoint } from '../../enums/checkpoint';
import { isTaxReturnComplete, isTaxReturnAwaitingPayment, isTaxReturnAwaitingRefund } from "../../hooks/TaxReturnState";


type TaxReturnStateContextType = { isLoading: boolean, checkpoint: Checkpoint|null, taxReturnCompleted: boolean, taxReturnNeedsPayment: boolean, taxReturnNeedsRefund: boolean };

const TransitionContainer: React.FC = () => {
    const {
      frontendState: { isLoading, checkpoint }
    } = useSelector((state: RootState) => state.state);
    const complete = isTaxReturnComplete();
    const needsPayment = isTaxReturnAwaitingPayment();
    const needsRefund = isTaxReturnAwaitingRefund();

    return (
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Layout>
            <Outlet context={
                {isLoading: isLoading, checkpoint: checkpoint, taxReturnCompleted: complete,
                 taxReturnNeedsPayment: needsPayment, taxReturnNeedsRefund: needsRefund
            } satisfies TaxReturnStateContextType}/>
        </Layout>
      </ErrorBoundary>
    );
};

export default TransitionContainer;

/*
 * Outlet components should use this
 * to access common state derived from Redux store
 */
export function useTransitionStateContext() {
  return useOutletContext<TaxReturnStateContextType>();
}
